import React from "react";
import ChatBox from "./ChatBox";
import "./chatbox.css";
import SectionCard from "../../generic/sectioncard/SectionCard";

const ChatBoxWrapper = ({ patient }) => {
  return (
    <>
      <SectionCard
        title="Updates"
        className="listCardStylingThirdRow no-scrollbar chat-box-wrapper"
      >
        <ChatBox patient={patient} />
      </SectionCard>
    </>
  );
};

export default ChatBoxWrapper;
